<div class="h-100 d-flex flex-column" *ngIf="lightColor">
  <app-title></app-title>
  
	<div class="flex-grow-1" style="overflow: auto;">
    <mat-card class="col-12 mb-4" style="margin: auto">
      <mat-card-content>
        <div class="d-flex flex-row p-2 align-items-center">
          <div class="p-2">
            <fa-icon
              [icon]="['fas', 'circle']"
              size="2x"
              [style.color]="lightColor"
            ></fa-icon>
          </div>
          <div class="p-2 ml-3 lead" [style.color]="lightColor" [innerHTML]="message | safeHtml">
          </div>
        </div>
        <div class="mt-3 mb-2 font-weight-bold display-card">
          {{ "DONT_FORGET_DISPLAY_CARD_TO_ADMISSION" | translated }}
        </div>
        <div class="text-center">
          <app-btn
            *ngIf="printLightEnabled"
            [dataTxt]="'PRINT_LIGHT'"
            [classes]="'w-75'"
            (callback)="onPrintLight()"
            [icon]="'print'"
            [iconLocation]="'left'"
          ></app-btn>
        </div>
      </mat-card-content>
    </mat-card>

    <div
    class="col-12 text-center p-2" *ngIf="nbPrinting > 0"
  >
    <span style="color: orange; font-weight: bold" *ngIf="isPrinting">{{
      "MEDICAL_FORM_PRINTING" | translated
    }}</span>

    <span style="font-weight: bold" *ngIf="! isPrinting && !printingError">{{
      "MEDICAL_FORM_PRINTED" | translated
    }}</span>

    <span style="color: red; font-weight: bold" *ngIf="!isPrinting && printingError">{{
      "MEDICAL_FORM_PRINTING_ERROR" | translated
    }}</span>
    
    <div *ngIf="isPrinting">
      <img src="assets/img/preloader-2.gif" />
    </div>
  </div>

    <mat-card
      *ngIf="medicalFormRequired"
      class="col-12 col-md-11 mb-4 text-center"
      style="margin: auto"
    >
      <mat-card-title>{{ "MEDICAL_FORM" | translated }}</mat-card-title>
      <mat-card-content>
        <div *ngIf="kioskMode && printMedicalFormEnabled" class="p-1">
          <app-btn
            [dataTxt]="'PRINT'"
            [classes]="'w-50'"
            (callback)="onPrintMedicalForm(false)"
            [icon]="'print'"
            [iconLocation]="'left'"
          ></app-btn>
        </div>

        <div *ngIf="!kioskMode" class="p-1">
          <label> {{ "MEDICAL_FORM_REQUIRED" | translated }}</label>
          <app-btn
            [classes]="'w-50'"
            [dataTxt]="'DOWNLOAD'"
            (callback)="onDownload()"
            [icon]="'download'"
            [iconLocation]="'left'"
          ></app-btn>
        </div>
        
        <span style="font-weight: bold" *ngIf="mailMedicalFormSend">{{
          "MEDICAL_FORM_SENT" | translated
        }}</span>
        
        <div class="p-1" *ngIf="nbSendMailMedicalForm < nbMaxSendMailMedicalForm">
          <div>
            <label *ngIf="!kioskMode">
              {{ "MEDICAL_FORM_SEND_MAIL" | translated }}
            </label>
            <label *ngIf="kioskMode">
              {{ "MEDICAL_FORM_SEND_MAIL_KIOSK" | translated }}
            </label>
          </div>
          <div>
            <app-btn
              [dataTxt]="'SEND'"
              [classes]="'w-50'"
              (callback)="onMail()"
              [icon]="'envelope'"
              [iconLocation]="'left'"
            ></app-btn>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'BACK_TO_HOME'"
        [classes]="'w-100 btnAnimation'"
        (callback)="onHome()"
        [icon]="'home'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
  </div>
</div>
